(() => {
  if (window.__l51BadgesInit) return;
  window.__l51BadgesInit = true;

  const CFG_ID = 'l51BadgesConfig';
  const SEL_PLACEHOLDER = '[data-l51-badges]';
  const MOBILE_MAX = 749;
  const OBS_THROTTLE_MS = 120;
  const TIME_REFRESH_MS = 30000;

  const toNum = (v, fallback = 0) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  };

  function readConfig() {
    const el = document.getElementById(CFG_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function splitTags(raw) {
    if (!raw) return [];
    return String(raw)
      .split('||')
      .map((t) => String(t || '').trim().toLowerCase())
      .filter(Boolean);
  }

  function parseDateTime(raw) {
    const s = String(raw || '').trim();
    if (!s) return null;

    let m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    if (m) {
      const y = Number(m[1]);
      const mo = Number(m[2]);
      const d = Number(m[3]);
      if (!y || mo < 1 || mo > 12 || d < 1 || d > 31) return null;
      return new Date(y, mo - 1, d, 0, 0, 0, 0);
    }

    m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(s);
    if (m) {
      const y = Number(m[1]);
      const mo = Number(m[2]);
      const d = Number(m[3]);
      const h = Number(m[4]);
      const mi = Number(m[5]);

      if (!y || mo < 1 || mo > 12 || d < 1 || d > 31) return null;
      if (h < 0 || h > 23 || mi < 0 || mi > 59) return null;

      return new Date(y, mo - 1, d, h, mi, 0, 0);
    }

    return null;
  }

  function hasExplicitTime(raw) {
    return /[ T]\d{2}:\d{2}$/.test(String(raw || '').trim());
  }

  function normalizeStart(raw) {
    const dt = parseDateTime(raw);
    if (!dt) return null;

    if (hasExplicitTime(raw)) return dt;
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0, 0);
  }

  function normalizeEnd(raw) {
    const dt = parseDateTime(raw);
    if (!dt) return null;

    if (hasExplicitTime(raw)) return dt;
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 23, 59, 59, 999);
  }

  function ruleIsActiveNow(rule, now = new Date()) {
    const sd = normalizeStart(rule.start_date);
    const ed = normalizeEnd(rule.end_date);

    if (sd && now < sd) return false;
    if (ed && now > ed) return false;

    return true;
  }

  function ruleAppliesToScope(rule, scope) {
    const sc = String(scope || 'card').toLowerCase();

    if (sc === 'card') return rule.show_on_card !== false;
    if (sc === 'pdp') return rule.show_on_pdp === true;

    return false;
  }

  function getCorner(cfg, rule, scope, isMobile) {
    const sc = String(scope || 'card').toLowerCase();
    let pos = '';

    if (rule && rule.use_custom_position) {
      if (sc === 'pdp') {
        pos = String(
          isMobile ? rule.pos_pdp_mobile : (rule.pos_pdp_desktop || 'tl')
        ).toLowerCase();
      } else {
        pos = String(
          isMobile ? rule.pos_card_mobile : (rule.pos_card_desktop || 'tl')
        ).toLowerCase();
      }
    } else {
      if (sc === 'pdp') {
        pos = String(
          isMobile
            ? (cfg?.position?.pdp?.mobile || 'tl')
            : (cfg?.position?.pdp?.desktop || 'tl')
        ).toLowerCase();
      } else {
        pos = String(
          isMobile
            ? (cfg?.position?.card?.mobile || 'tl')
            : (cfg?.position?.card?.desktop || 'tl')
        ).toLowerCase();
      }
    }

    if (pos === 'tr' || pos === 'bl' || pos === 'br') return pos;
    return 'tl';
  }

  function getFlow(cfg, isMobile) {
    const d = (cfg && cfg.flow && cfg.flow.desktop) ? cfg.flow.desktop : {};
    const m = (cfg && cfg.flow && cfg.flow.mobile) ? cfg.flow.mobile : {};
    const F = isMobile ? m : d;

    const direction = String(F.direction || 'column').toLowerCase() === 'row' ? 'row' : 'column';
    const perRow = Math.max(1, toNum(F.per_row, 3));
    const gap = Math.max(0, toNum(F.gap, 6));

    return { direction, perRow, gap };
  }

  function getEdgePadding(cfg, isMobile) {
    const ep = cfg && cfg.edge_padding ? cfg.edge_padding : {};
    return Math.max(0, toNum(isMobile ? ep.mobile : ep.desktop, 0));
  }

  function getLimit(cfg, scope) {
    const limits = cfg && cfg.limits ? cfg.limits : {};
    if (String(scope).toLowerCase() === 'pdp') {
      return Math.max(1, toNum(limits.pdp, 99));
    }
    return Math.max(1, toNum(limits.card, 99));
  }

  function applyFlowToStack(stack, flow) {
    stack.style.gap = `${flow.gap}px`;

    if (flow.direction === 'row') {
      stack.style.display = 'grid';
      stack.style.gridTemplateColumns = `repeat(${flow.perRow}, max-content)`;
      stack.style.gridAutoFlow = 'row';
      stack.style.alignItems = 'start';
      stack.style.justifyItems = 'start';
      stack.style.flexDirection = '';
      stack.style.flexWrap = '';
    } else {
      stack.style.display = 'flex';
      stack.style.flexDirection = 'column';
      stack.style.flexWrap = 'nowrap';
      stack.style.alignItems = 'flex-start';
      stack.style.gridTemplateColumns = '';
      stack.style.gridAutoFlow = '';
      stack.style.justifyItems = '';
    }
  }

  function ensureCornerStack(placeholder, corner, flow, edgePad) {
    const key = `corner:${corner}`;
    let stack = placeholder.querySelector(`.l51-badges__stack[data-stack-key="${CSS.escape(key)}"]`);

    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'l51-badges__stack';
      stack.setAttribute('data-stack-key', key);
      stack.setAttribute('data-corner', corner);
      placeholder.appendChild(stack);
    }

    stack.style.top = '';
    stack.style.right = '';
    stack.style.bottom = '';
    stack.style.left = '';

    if (corner === 'tl') {
      stack.style.top = `${edgePad}px`;
      stack.style.left = `${edgePad}px`;
    }
    if (corner === 'tr') {
      stack.style.top = `${edgePad}px`;
      stack.style.right = `${edgePad}px`;
    }
    if (corner === 'bl') {
      stack.style.bottom = `${edgePad}px`;
      stack.style.left = `${edgePad}px`;
    }
    if (corner === 'br') {
      stack.style.bottom = `${edgePad}px`;
      stack.style.right = `${edgePad}px`;
    }

    applyFlowToStack(stack, flow);
    return stack;
  }

  function clearInjected(placeholder) {
    placeholder.querySelectorAll('.l51-badges__stack').forEach((el) => el.remove());
  }

  function makeBadge(rule, isMobile) {
    const type = String(rule.badge_type || 'both').toLowerCase();

    if (type === 'image' && !rule.image) return null;
    if (type === 'text' && !rule.label) return null;
    if (type === 'both' && !rule.image && !rule.label) return null;

    const badge = document.createElement('div');
    badge.className = 'l51-badge';
    badge.setAttribute('data-rule-id', rule.id || '');

    if (rule.bg) badge.style.background = rule.bg;
    if (rule.text) badge.style.color = rule.text;

    const bw = toNum(rule.border_w, 0);
    if (bw > 0) {
      badge.style.borderStyle = 'solid';
      badge.style.borderWidth = `${bw}px`;
      if (rule.border) badge.style.borderColor = rule.border;
    } else {
      badge.style.borderStyle = 'none';
      badge.style.borderWidth = '0px';
    }

    badge.style.borderRadius = `${toNum(rule.radius, 0)}px`;
    badge.style.fontSize = `${toNum(isMobile ? rule.font_m : rule.font_d, 12)}px`;

    if ((type === 'image' || type === 'both') && rule.image) {
      const wrap = document.createElement('span');
      wrap.className = 'l51-badge__img-wrap';

      const w = toNum(isMobile ? rule.img_w_m : rule.img_w_d, 16);
      wrap.style.width = `${w}px`;

      const img = document.createElement('img');
      img.className = 'l51-badge__img';
      img.src = rule.image;
      img.alt = rule.label || rule.trigger_tag || 'badge';
      img.loading = 'lazy';

      wrap.appendChild(img);
      badge.appendChild(wrap);
    }

    if (type === 'text' || type === 'both') {
      const span = document.createElement('span');
      span.className = 'l51-badge__text';
      span.textContent = rule.label || '';
      badge.appendChild(span);
    }

    return badge;
  }

  function buildSignature({ tags, scope, isMobile, flow, edgePad, limit, matched, cfg }) {
    const rulesSig = matched
      .map((r) => [
        r.id,
        String(r.trigger_tag || ''),
        String(r.badge_type || ''),
        String(r.label || ''),
        String(r.image || ''),
        String(r.use_custom_position),
        String(r.pos_card_desktop || ''),
        String(r.pos_card_mobile || ''),
        String(r.pos_pdp_desktop || ''),
        String(r.pos_pdp_mobile || ''),
        String(r.show_on_card),
        String(r.show_on_pdp),
        String(r.start_date || ''),
        String(r.end_date || ''),
        String(r.priority || ''),
        String(r.sort_index || '')
      ].join('~'))
      .join('||');

    const flowSig = `${flow.direction}|${flow.perRow}|${flow.gap}`;
    const globalPosSig = [
      cfg?.position?.card?.desktop || 'tl',
      cfg?.position?.card?.mobile || 'tl',
      cfg?.position?.pdp?.desktop || 'tl',
      cfg?.position?.pdp?.mobile || 'tl'
    ].join('|');

    return `m:${isMobile ? 1 : 0}|s:${scope}|t:${tags.join(',')}|f:${flowSig}|p:${edgePad}|l:${limit}|gp:${globalPosSig}|r:${rulesSig}`;
  }

  function applyBadges(root = document) {
    const cfg = readConfig();
    if (!cfg || !cfg.enabled) return;

    const isMobile = window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;
    const flow = getFlow(cfg, isMobile);
    const edgePad = getEdgePadding(cfg, isMobile);
    const now = new Date();

    const rules = Array.isArray(cfg.rules) ? cfg.rules.slice() : [];

    rules.sort((a, b) => {
      const pa = toNum(a.priority, 50);
      const pb = toNum(b.priority, 50);
      if (pa !== pb) return pa - pb;

      const ia = toNum(a.sort_index, 9999);
      const ib = toNum(b.sort_index, 9999);
      return ia - ib;
    });

    root.querySelectorAll(SEL_PLACEHOLDER).forEach((ph) => {
      const scope = String(ph.getAttribute('data-scope') || 'card').toLowerCase();
      const tags = splitTags(ph.getAttribute('data-tags'));
      const limit = getLimit(cfg, scope);

      if (!tags.length) return;

      const matched = [];
      for (const r of rules) {
        if (!r || !r.trigger_tag) continue;
        if (!ruleAppliesToScope(r, scope)) continue;
        if (!ruleIsActiveNow(r, now)) continue;

        const trig = String(r.trigger_tag).trim().toLowerCase();
        if (!trig) continue;
        if (!tags.includes(trig)) continue;

        if (String(r.badge_type).toLowerCase() === 'image' && !r.image) continue;

        const nodeTest = makeBadge(r, isMobile);
        if (!nodeTest) continue;

        matched.push(r);
      }

      const visibleMatched = matched.slice(0, limit);

      const sig = buildSignature({
        tags,
        scope,
        isMobile,
        flow,
        edgePad,
        limit,
        matched: visibleMatched,
        cfg
      });

      if (ph.dataset.l51Sig === sig) return;
      ph.dataset.l51Sig = sig;

      clearInjected(ph);
      if (!visibleMatched.length) return;

      const byCorner = { tl: [], tr: [], bl: [], br: [] };

      visibleMatched.forEach((r) => {
        const c = getCorner(cfg, r, scope, isMobile);
        (byCorner[c] || (byCorner[c] = [])).push(r);
      });

      Object.keys(byCorner).forEach((corner) => {
        const list = byCorner[corner];
        if (!list || !list.length) return;

        const stack = ensureCornerStack(ph, corner, flow, edgePad);

        list.forEach((r) => {
          const node = makeBadge(r, isMobile);
          if (node) stack.appendChild(node);
        });
      });
    });
  }

  function forceTimeRefresh() {
    document.querySelectorAll(SEL_PLACEHOLDER).forEach((ph) => {
      delete ph.dataset.l51Sig;
    });
    applyBadges(document);
  }

  document.addEventListener('shopify:section:load', (e) => applyBadges(e.target));
  document.addEventListener('shopify:section:reorder', (e) => applyBadges(e.target));
  document.addEventListener('shopify:section:select', (e) => applyBadges(e.target));
  document.addEventListener('shopify:section:render', (e) => applyBadges(e.target));

  const _pushState = history.pushState;
  const _replaceState = history.replaceState;

  function onUrlChange() {
    setTimeout(() => forceTimeRefresh(), 60);
    setTimeout(() => startObserver(), 120);
  }

  history.pushState = function () {
    _pushState.apply(this, arguments);
    onUrlChange();
  };

  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    onUrlChange();
  };

  window.addEventListener('popstate', onUrlChange);

  let resizeTO = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTO);
    resizeTO = setTimeout(() => forceTimeRefresh(), 180);
  }, { passive: true });

  function findObservationRoots() {
    const selectors = ['#CollectionLoop', '[data-product-grid]', '.product-grid', '.grid--products', 'main'];
    const roots = [];

    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        if (el && !roots.includes(el)) roots.push(el);
      });
    });

    if (!roots.length) roots.push(document.body);
    return roots;
  }

  let moTimer = null;
  let observer = null;
  let clockTimer = null;

  function startObserver() {
    if (observer) observer.disconnect();

    observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((m) => {
        if (m.target && m.target.closest && m.target.closest('.l51-badges')) return false;

        if (m.addedNodes && m.addedNodes.length) {
          for (const n of m.addedNodes) {
            if (!(n instanceof Element)) continue;
            if (n.matches('.l51-badges, .l51-badges__stack, .l51-badge')) continue;
            if (n.closest && n.closest('.l51-badges')) continue;

            if (n.matches && n.matches('[data-l51-badges]')) return true;
            if (n.querySelector && n.querySelector('[data-l51-badges]')) return true;
          }
        }

        return false;
      });

      if (!relevant) return;

      clearTimeout(moTimer);
      moTimer = setTimeout(() => forceTimeRefresh(), OBS_THROTTLE_MS);
    });

    const roots = findObservationRoots();
    roots.forEach((root) => observer.observe(root, { childList: true, subtree: true }));
  }

  function startTimeRefresh() {
    if (clockTimer) clearInterval(clockTimer);

    clockTimer = setInterval(() => {
      forceTimeRefresh();
    }, TIME_REFRESH_MS);
  }

  window.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      forceTimeRefresh();
      startTimeRefresh();
    }
  });

  window.addEventListener('load', () => {
    startObserver();
    startTimeRefresh();
    forceTimeRefresh();
  });

  window.addEventListener('pageshow', () => {
    startObserver();
    startTimeRefresh();
    forceTimeRefresh();
  });

  document.addEventListener('DOMContentLoaded', () => {
    startObserver();
    startTimeRefresh();
    forceTimeRefresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => forceTimeRefresh());
  } else {
    forceTimeRefresh();
    startTimeRefresh();
  }
})();